<div class="carousel-container">
  <div class="carousel flex" #carousel (scroll)="updateCurrentIndex()" (window:resize)="updateCurrentIndex()"
    (mousedown)="startDragging($event, false)" (mouseup)="stopDragging($event, false)" 
    (click)="onclick($event)"
    (mouseleave)="stopDragging($event, false)" (mousemove)="moveEvent($event)">
    <div [class.carousel-moving]="mouseDown" class="flex ">
      <ng-container *ngFor="let item of items">
        <div #carouselItem>
          <ng-container [ngTemplateOutlet]="item.tpl"></ng-container>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="carousel-button" style="left: 0px" (click)="prev()" *ngIf="!atStart">
    <fa-icon icon="chevron-left"></fa-icon>
  </div>
  <div class="carousel-button" style="right: 0px" (click)="next()" *ngIf="!atEnd">
    <fa-icon icon="chevron-right"></fa-icon>
  </div>
</div>